export const debugLog = (message: string, obj: unknown) => {
  try {
    if (localStorage.getItem('@linzjs/windows.debugEnabled') == 'true') {
      console.debug(`@linzjs/windows: ${message}`, obj);
    }
  } catch (e) {
    console.error(e);
  }
};
